import { Heap } from 'features/Analytics/vendors/heap';
import { Mixpanel } from 'features/Analytics/vendors/mixpanel';

const isMixpanelEnabled = () => {
	return process.env.REACT_APP_MIXPANEL_TOKEN;
};

const isHeapEnabled = process.env.REACT_APP_HEAP_ID;

export const initTracking = () => {
	isMixpanelEnabled() && Mixpanel.init();
	// heap.load() is called in HTML file as instructed in Heap documentation
};

export const identifyUser = (userId: string) => {
	isMixpanelEnabled() && Mixpanel.identify(userId);
	isHeapEnabled && Heap.identify(userId);
};

export const track = (
	eventName: string,
	eventProperties: Record<string, any>
) => {
	isHeapEnabled && Heap.track(eventName, eventProperties);
	isMixpanelEnabled() && Mixpanel.track(eventName, eventProperties);
};

export const addUserProperties = (userProperties: Record<string, any>) => {
	isHeapEnabled && Heap.addUserProperties(userProperties);
	isMixpanelEnabled() && Mixpanel.addUserProperties(userProperties);
};

export const addEventProperties = (
	eventName: string,
	eventProperties: Record<string, any>
) => {
	isHeapEnabled && Heap.addEventProperties(eventName, eventProperties);
	isMixpanelEnabled() && Mixpanel.track(eventName, eventProperties);
};

export const clearEventProperties = () => {
	isHeapEnabled && Heap.clearEventProperties();
};

export const trackPageView = (eventProperties?: Record<string, any>) => {
	isMixpanelEnabled() && Mixpanel.trackPageView(eventProperties || {});
};

export const resetAnalytics = () => {
	isMixpanelEnabled() && Mixpanel.reset();
};
